<template>
  <div>
    <div class="card" id="editor">
      <div class="card-body">
        <div class="mx-lg-4 mt-2 mx-xl-4 mx-md-4 mx-sm-2 mb-2">
          <div id="editorjs" class="editor"></div>
        </div>
      </div>
    </div>
    <div v-if="v$.description_source.$invalid">
      <span :class="{'is-invalid': v$.description_source.$invalid && v$.description_source.$dirty}"></span>
      <div class="invalid-feedback" v-for="error of v$.description_source.$silentErrors" :key="error.$uid">
        {{ error.$message }}
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, onUnmounted, ref, reactive, watch} from "vue"
import {editor} from "@/plugins/editor/editor1"
import {useVuelidate} from "@vuelidate/core"
import {minLength} from "@/plugins/vuelidator"
import Undo from 'editorjs-undo'

export default defineComponent({
  name: "Editor",
  props: {
    description_source: {
      type: Object,
    },
    validations: {
      //type: Object,
    },
  },
  setup(props, {emit}) {
    let editorObject = ref(null)
    let description_source = ref(props.description_source)

    let $externalResults = reactive({})

    const fields = reactive({
      description_source: description_source.value,
    })

    const rules = {
      description_source: {
        minLength: minLength(0)
      },
    }

    const v$ = useVuelidate(rules, fields, {$externalResults})

    onMounted(() => {
      initEditor()
    })

    onUnmounted(() => {
      destroyEditor()
    })

    watch(() => props.validations, (val) => {
      validate(() => {
        if (val?.description_source !== undefined) {
          $externalResults.description_source = val["description_source"][0]
        }
      })
    })

    function validate(fn) {
      v$.value.$clearExternalResults()
      return v$.value.$validate().then(() => {
        fn()
      })
    }

    function initEditor() {
        editorObject.value = editor({
          id: 'editorjs',
          data: description_source.value,
          onReady: () => {
            const undo = new Undo({ editor: editorObject.value })
            if (description_source.value !== null) {
              undo.initialize(description_source.value)
            }
          },
          onChange: () => {
            editorObject.value.save().then((savedData) => {
              description_source.value = savedData
              validate(() => {})
              emit("onChange", savedData)
            })
          },
        })
    }

    function destroyEditor() {
      if (editorObject.value) {
        editorObject.value.destroy()
      }
    }

    return {
      v$,
    }
  }
})
</script>

<style scoped>

</style>
